// extracted by mini-css-extract-plugin
module.exports = {"container":"ZipCodeInput_container__qaYxY","switchLabel":"ZipCodeInput_switchLabel__24vs1","form":"ZipCodeInput_form__Bddch"};